"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TableOfContentsLink = _ref => {
  let {
    hashRef,
    item,
    onClick,
    onKeyPress,
    sectionId,
    select
  } = _ref;
  const id = item.props['data-id'];
  if (!id) return;
  const anchorProps = {
    'aria-label': item.props?.name,
    className: 'mm-scrollspy-list-group-item',
    'data-spy-id': id,
    href: `#${id}`,
    key: id,
    onClick,
    onKeyPress,
    ref: window.location.hash === `#${id}` ? hashRef : null,
    title: item.props?.name
  };

  // sets styles for active scrollspy section
  if (sectionId === id) {
    anchorProps.className += ' active';
  }
  // expands table of contents menu, including active section
  if (select) {
    anchorProps.className += ' select';
  }
  return /*#__PURE__*/_react.default.createElement("a", anchorProps, item.props?.name || id);
};
TableOfContentsLink.displayName = 'TableOfContents.Link';
TableOfContentsLink.propTypes = {
  hashRef: _propTypes.default.object.isRequired,
  item: _propTypes.default.object,
  onClick: _propTypes.default.func.isRequired,
  onKeyPress: _propTypes.default.func.isRequired,
  sectionId: _propTypes.default.string,
  select: _propTypes.default.bool.isRequired
};
const TableOfContents = _ref2 => {
  let {
    isVisible,
    menuItems,
    onClick,
    onKeyPress,
    sectionId,
    select
  } = _ref2;
  const [didScrollTarget, setDidScrollTarget] = (0, _react.useState)(false);
  const hashRef = (0, _react.useRef)();

  // let's face it, this is really difficult to test
  /* istanbul ignore next */
  (0, _react.useEffect)(() => {
    if (didScrollTarget) return;
    const scroller = setInterval(() => {
      if (hashRef.current) {
        const fakeEvt = {
          preventDefault: () => {},
          currentTarget: hashRef.current
        };
        onClick(fakeEvt);
        clearInterval(scroller);
        setDidScrollTarget(true);
      }
    }, 200);
    return function cleanup() {
      clearInterval(scroller);
    };
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `mm-scrollspy-list-group ${isVisible ? '' : 'hide'}`
  }, menuItems.map((item, idx) => /*#__PURE__*/_react.default.createElement(TableOfContentsLink, {
    key: idx,
    hashRef: hashRef,
    item: item,
    onClick: onClick,
    onKeyPress: onKeyPress,
    sectionId: sectionId,
    select: select
  })));
};
TableOfContents.Link = TableOfContentsLink;
TableOfContents.propTypes = {
  isVisible: _propTypes.default.bool.isRequired,
  menuItems: _propTypes.default.array.isRequired,
  onClick: _propTypes.default.func.isRequired,
  onKeyPress: _propTypes.default.func.isRequired,
  sectionId: _propTypes.default.string,
  select: _propTypes.default.bool.isRequired
};
var _default = exports.default = TableOfContents;